import {
  createStyles,
  TextField,
  type WithStyles,
  withStyles,
} from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React, { type ChangeEvent } from "react";
import type { CorralFilterFormState } from "../corral.types";

type CorralFilterFormProps = {
  filterForm: CorralFilterFormState;
  onChangeFilter: <T extends keyof CorralFilterFormState>(
    field: T,
    value: CorralFilterFormState[T]
  ) => void;
} & WithStyles<typeof styles>;

function CorralFilterForm({
  classes,
  filterForm,
  onChangeFilter,
}: CorralFilterFormProps) {
  const { t } = useTranslations();

  const handleChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
    onChangeFilter("searchText", event.target.value);
  };

  return (
    <div className={classes.root}>
      <TextField
        autoFocus={true}
        className={classes.searchField}
        data-testid="search-filter-field"
        label={t("locales:search-corrals")}
        onChange={handleChangeSearch}
        value={filterForm.searchText}
      />
    </div>
  );
}

const styles = () =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      gap: "32px",
      paddingTop: "20px",
      width: "100%",
    },
    searchField: {
      width: "400px",
    },
  });

export default withStyles(styles)(CorralFilterForm);
